var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreezeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6085 9.72495V5.47778C14.6085 2.9366 12.5411 0.869141 9.99991 0.869141C7.45867 0.869141 5.39126 2.9366 5.39126 5.47778V9.72495C4.62405 10.7126 4.1665 11.9522 4.1665 13.2968C4.1665 16.5134 6.78337 19.1302 9.99991 19.1302C13.2164 19.1302 15.8333 16.5134 15.8333 13.2968C15.8333 11.9522 15.3758 10.7126 14.6085 9.72495ZM6.40577 5.47778C6.40577 3.49595 8.01807 1.88365 9.99991 1.88365C11.9817 1.88365 13.594 3.49595 13.594 5.47778V8.70523C12.6028 7.92761 11.3546 7.46342 9.99991 7.46342C8.64524 7.46342 7.39699 7.92761 6.40577 8.70528V5.47778ZM9.99991 18.1157C7.34277 18.1157 5.18101 15.954 5.18101 13.2968C5.18101 10.6397 7.34277 8.47793 9.99991 8.47793C12.657 8.47793 14.8188 10.6397 14.8188 13.2968C14.8188 15.954 12.657 18.1157 9.99991 18.1157Z",
    fill: "#7C63A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99982 10.8535C9.18613 10.8535 8.52417 11.5155 8.52417 12.3292C8.52417 12.9647 8.92799 13.5077 9.49257 13.7149V15.2343H10.5071V13.7149C11.0716 13.5077 11.4755 12.9646 11.4755 12.3292C11.4755 11.5155 10.8135 10.8535 9.99982 10.8535ZM9.99982 12.7903C9.74553 12.7903 9.53867 12.5834 9.53867 12.3292C9.53867 12.0749 9.74553 11.868 9.99982 11.868C10.2541 11.868 10.461 12.0749 10.461 12.3292C10.461 12.5834 10.2541 12.7903 9.99982 12.7903Z",
    fill: "#7C63A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreezeIcon);
export default __webpack_public_path__ + "static/media/freeze-icon.9eb6706cba3536341963ffbe5acceb94.svg";
export { ForwardRef as ReactComponent };